import { render } from "./AddBankAccount.vue?vue&type=template&id=80335282"
import script from "./AddBankAccount.vue?vue&type=script&lang=js"
export * from "./AddBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__